module.exports = __webpack_public_path__ + "img/homepage_3--mobile.da4f1a67.jpg";